/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const featuresConstans = {
    FEATURES_LIST_ACTIVE: 'features_list_active',
    FEATURES_LIST: 'features_list',
    FEATURES_ITEM: 'features_item',
    FEATURES_PUT: 'features_put',
    FEATURES_POST: 'features_post',
    FEATURES_REFRESH_LIST: 'features_refresh_list',

    FEATURES_GROUP_LIST: 'features_group_list',
    FEATURES_TYPE_BY_GROUP_LIST: 'features_type_by_group_list',
};

export class featuresActions extends defaultActions {}
